import { cn } from "@/components/podkit/lib/cn";

export function DropdownMenu({
    children,
    className,
    width,
}: React.PropsWithChildren<{ className?: string; width: number }>) {
    return (
        <div className={cn("mt-1", className)} style={{ width }}>
            {children}
        </div>
    );
}
